module.exports = global["React"] = require("-!D:\\xampp\\htdocs\\react-2048\\node_modules\\react\\dist\\react.min.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/react/dist/react.min.js
 ** module id = 1
 ** module chunks = 0
 **/